import { getSearchResults } from "@/features/diets/api/get-diets-results";
import { mapDietSearchResultsToDietCatalog } from "@/features/diets/helpers/mappers";
import { DietCatalogCarouselSlider } from "@/features/static-builder/components/diet-catalog-carousel/diet-catalog-carousel-slider";

/**
 * Carousel of diets belonging to the offer catering (matched in the CMS by
 * the searched phrase). Rendered only in the no-results offer variant.
 */
export const NoResultsOfferDiets = async ({
  cateringId,
}: {
  cateringId: string;
}) => {
  const data = await getSearchResults({ cateringId, pagination: false });
  const diets = mapDietSearchResultsToDietCatalog(data)["hydra:member"];

  if (diets.length === 0) {
    return null;
  }

  return (
    <DietCatalogCarouselSlider
      diets={diets}
      key="no-results-offer-diets"
      showMenu
    />
  );
};
